import { render, staticRenderFns } from "./CreateStaffDialog.vue?vue&type=template&id=4d6c53ad"
import script from "./CreateStaffDialog.vue?vue&type=script&lang=js"
export * from "./CreateStaffDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports